import React, { useContext, useEffect, useState } from 'react';
import DataReportSheet from '@nile/reports/src/modules/DataReports/components/subpages/DataReportSheet';
import { SkeletonLoading, toast, getTranslatedText } from '@nile/components';
import { useMutation } from '@apollo/client';
import {
  UPDATE_REPORT,
  CREATE_REPORT,
  GET_REPORT
} from '@nile/reports/src/modules/DataReports/graphql';
import {
  AccountClient,
  useCachedQuery,
  RMMClient,
  GET_ENTITY_PROPERTIES
} from '@nile/graphql';
import ReportsContext from '@nile/reports/src/modules/home/contexts/Reports';
import {
  CUSTOM_VIEW,
  DATA_REPORT
} from '@nile/reports/src/modules/home/constants';
import { useIntl } from 'react-intl';

function DataReportContainer(props) {
  const { mode, reportId = null, source, closeModal } = props;
  const reportsContext = useContext(ReportsContext);
  const intl = useIntl();

  const [data, setData] = useState(null);
  const [modalLoading, setModalLoading] = useState(true);

  const getReport = () => {
    AccountClient.query({
      query: GET_REPORT,
      variables: {
        reportId: reportId
      },
      fetchPolicy: 'network-only'
    })
      .then((res) => {
        if (res?.data?.getReport) {
          const resdata = reportsContext?.cloneId
            ? {
                ...res.data.getReport,
                name: `${res.data.getReport.name} - ${getTranslatedText(
                  intl,
                  'common.clone'
                )}`
              }
            : res.data.getReport;
          setData(resdata);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const { loading, data: meta } = useCachedQuery(GET_ENTITY_PROPERTIES, {
    client: RMMClient
  });

  const [createNewReport] = useMutation(CREATE_REPORT, {
    client: AccountClient,
    onCompleted({ createReport }) {
      if (createReport) {
        reportsContext.setNewReportId({
          id: createReport.reportId,
          type: DATA_REPORT
        });
        if (reportsContext?.cloneId) {
          reportsContext.setCloneId(null);
          reportsContext.setActiveView(CUSTOM_VIEW);
        }
        toast('success', 'reports.datareport.createDataReport.success');
        reportsContext.getAllReports();
        closeModal();
      }
    }
  });

  const [updateReport] = useMutation(UPDATE_REPORT, {
    client: AccountClient,
    onCompleted({ updateReport: updatedData }) {
      if (updatedData) {
        setData(updatedData);
        toast('success', 'reports.datareport.updateDatareport.success');
        reportsContext.getAllReports();
        reportsContext.setRefreshDataReport(true);
      }
    }
  });

  useEffect(() => {
    if (reportId) {
      getReport(reportId);
    }
  }, [reportId]);

  useEffect(() => {
    setTimeout(() => setModalLoading(false), 1000);
  }, []);

  if (loading || modalLoading)
    return (
      <SkeletonLoading
        hideStepNav
        hideTable
        showCardView
        hideSecondaryHeader
        cardViewCustomClassName="full-width vh55 m20 rounded-4px"
      />
    );

  return (
    <DataReportSheet
      data={data}
      closeModal={closeModal}
      meta={meta?.getEntitiesMeta || []}
      mode={mode}
      reportsContext={reportsContext}
      source={source}
      updateReport={updateReport}
      createNewReport={createNewReport}
    />
  );
}

export default DataReportContainer;
